<template>
  <div>
    <div class="table-responsive">
      <div
        id="zero_config_wrapper"
        class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
      >
        <div class="row" style="height: 15rem; overflow: auto">
          <div class="col-sm-12">
            <table id="zero_config" class="table">
              <thead class="data-table-bg">
                <tr>
                  <th
                    :key="index"
                    v-for="(column, index) in tableColumns"
                    style="cursor: pointer; text-align: center"
                  >
                    {{ column[0] }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="items.length">
                <tr
                  :key="`${index}`"
                  v-for="(data, index) in items"
                  style="cursor: pointer; text-align: left"
                  :class="{
                    'data-table-bg': index % 2 !== 0,
                  }"
                >
                  <td>
                    {{ formatDate(data.deliveryDate) }}
                  </td>
                  <td style="text-transform: capitalize;">{{ data.name }}</td>
                  <td>{{ data.weight }}</td>
                  <td>{{ data.quantity }}</td>
                  <td style="text-transform: capitalize;">
                    {{ data.dataLogger.settings.name }}
                  </td>
                  <td>
                    {{ data.price }}
                  </td>
                  <td style="text-transform: capitalize;">
                    {{ data.description }}
                  </td>
                  <td style="text-transform: capitalize;">
                    {{ data.dataLogger.settings.name }}
                  </td>
                  <td style="text-transform: capitalize;">
                    {{ data.dataLoggerSettings && data.dataLoggerSettings.minTemperature ? data.dataLoggerSettings.minTemperature + ' °C' : '' }}
                  </td>
                  <td style="text-transform: capitalize;">
                    {{ data.dataLoggerSettings && data.dataLoggerSettings.maxTemperature ? data.dataLoggerSettings.maxTemperature + ' °C' : '' }}
                  </td>
                  <td style="text-transform: capitalize;">
                    {{ data.dataLoggerSettings && data.dataLoggerSettings.minHumidity ? data.dataLoggerSettings.minHumidity + ' %' : '' }}
                  </td>
                  <td style="text-transform: capitalize;">
                    {{ data.dataLoggerSettings && data.dataLoggerSettings.maxHumidity ? data.dataLoggerSettings.maxHumidity + ' %' : '' }}
                  </td>
                  <td>
                    <div class="d-flex align-items-center col-gap-1">
                      <span
                        class="cursor-pointer"
                        @click="$emit('edit_item', data, index)"
                      >
                        <IconEdit />
                      </span>
                      <span
                        class="cursor-pointer"
                        @click="$emit('delete_item', index)"
                      >
                        <IconDeleteUser />
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody style="height: 10rem" v-else>
                <tr>
                  <td colspan="15" class="">
                    <div
                      class="d-flex justify-content-center align-items-center"
                      style="height: 8rem"
                    >
                      <div
                        class="cursor-pointer d-flex justify-content-center align-items-center"
                        @click="$emit('showAddItemModal')"
                      >
                        <icon-circle-add class="mr-2" />
                        <span class="text-primary">{{ $t("add_item") }}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import IconCircleAdd from "../../../components/Iconsvg/IconCircleAdd.vue";
import IconDeleteUser from "../../../components/Iconsvg/IconDeleteUser.vue";
import IconEdit from "../../../components/Iconsvg/IconEditUser.vue";

export default {
  components: { IconCircleAdd, IconDeleteUser, IconEdit },
  name: "ItemsDetailsStep",
  props: {
    items: Array,
  },
  computed: {
    tableColumns() {
      return [
        [this.$t("Date & Time"), "column1"],
        [this.$t("item_name"), "column2"],
        [this.$t("wgt"), "column3"],
        [this.$t("Qty"), "column4"],
        [this.$t("devices"), "column5"],
        [this.$t("price"), "column6"],
        [this.$t("description"), "column7"],
        [this.$t("device"), "column8"],
        [this.$t("minTemp"), "column9"],
        [this.$t("maxTemp"), "column10"],
        [this.$t("minHumd"), "column11"],
        [this.$t("maxHumd"), "column12"],
        [this.$t("actions"), "actions"],
      ];
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YY HH:mm");
    },
  },
  mounted() {
    console.log(this.items);
  },
};
</script>

<style scoped></style>
